import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { SvgComponent } from '@components/svg.component';
import { HttpError } from '@models/http-error.model';
import { TerminalModel } from '@models/terminal/terminal.model';
import { TerminalService } from '@services/terminal.service';
import { HistoryService } from '@services/history.service';

@Component({
  selector: 'app-choose-instance-page',
  imports: [TranslateModule, SvgComponent],
  templateUrl: './choose-instance-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: { class: 'block h-full' },
})
export class ChooseInstancePageComponent implements OnInit {
  private readonly historyService = inject(HistoryService);
  private readonly terminalService = inject(TerminalService);
  private readonly toastr = inject(ToastrService);
  private readonly translate = inject(TranslateService);

  readonly terminals = signal<TerminalModel[]>([]);
  readonly isLoading = signal(true);

  ngOnInit(): void {
    this.terminalService.getTerminals().subscribe({
      next: (terminals) => {
        this.terminals.set(terminals);
        this.isLoading.set(false);
      },
      error: (err: HttpError) => {
        this.isLoading.set(false);
        this.toastr.error(
          this.translate.instant(err.message),
          this.translate.instant('choose_instance.errors.load_error_title'),
        );
      },
    });
  }

  selectTerminal(terminal: TerminalModel): void {
    this.terminalService.selectTerminal(terminal);
    this.historyService.back();
  }

  getInstanceLabel(terminal: TerminalModel): string {
    return this.terminalService.getInstanceLabel(terminal);
  }

  goBack(): void {
    this.historyService.back();
  }
}
